// the likelihood drawer will vary from city to city
import ToledoNeighborhoodSummaryDrawer from "./toledo.js"
import RichmondNeighborhoodSummaryDrawer from "./richmond.js"

export const NeighborhoodSummaryDrawer = (
  process.env.REACT_APP_CITY==="TOLEDO"
) ? ToledoNeighborhoodSummaryDrawer : RichmondNeighborhoodSummaryDrawer;

export default NeighborhoodSummaryDrawer;
